import produce from "immer";
import moment, { Moment } from "moment";
import {
  ActionType,
  SetSelectedDateAction,
  SetSortOptionsAction,
} from "history/actions";
import { SortAscDesc } from "typings/globalGQLTypes";

export enum HistorySortColumn {
  assignee = "assignee",
  completedAt = "completed_at",
  createdAt = "created_at",
  location = "location",
  name = "name",
  priority = "priority",
}

export interface HistorySortInput {
  column: HistorySortColumn;
  order: SortAscDesc;
}

export interface HistoryState {
  selectedDate: Moment;
  sort: HistorySortInput[];
}

export type AllHistoryActions = SetSelectedDateAction | SetSortOptionsAction;

const initialSort = [
  {
    column: HistorySortColumn.createdAt,
    order: SortAscDesc.asc,
  },
];

export const initialState: HistoryState = {
  selectedDate: moment().startOf("day"),
  sort: initialSort,
};

export const historyReducer = (
  state = initialState,
  action: AllHistoryActions,
) =>
  produce(state, draft => {
    switch (action.type) {
      case ActionType.SetSelectedDate: {
        draft.selectedDate = action.payload;
        return draft;
      }

      case ActionType.SetSortOptions: {
        draft.sort = action.payload;
        return draft;
      }

      default:
        return draft;
    }
  });
